import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { PirepsSvgComponent } from './pireps-svg/pireps-legend-svg';

export const PIREPS_LEGEND: TwcLegendParams = {
  title: 'PIREPS',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: PirepsSvgComponent },
  legendComponent: TwcLegendComponent
};
